export default __webpack_public_path__ + "static/media/b46834502217ec3d5a0e679a826b28f5.jpg";